import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
// import { tap, map, catchError } from 'rxjs/operators';
import { ToastController } from '@ionic/angular';
import { AuthService } from './services/auth-service/auth-service';
import { EnvService } from './services/env-service/env-service';
import { EventsService } from './services/eventsService';


@Injectable()
export class HttpInterceptor2 implements HttpInterceptor {

  constructor(
    public toastController: ToastController,
    public envService: EnvService,
    public authService: AuthService,
    private events: EventsService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let req = request.clone();

    req = req.clone({
      setHeaders: {
        'Accept': 'application/json'
      }
    });

    // console.log('added Accept to the request headers --> ' + JSON.stringify(req.headers));

    if (!req.headers.has('Content-Type')) {
      req = req.clone({
        setHeaders: {
          'content-type': 'application/json'
        }
      });
      // console.log('added content type to the request headers --> ' + JSON.stringify(req.headers));
    }

    const token = this.authService.getAuthToken();

    // console.log('original req.url ' + req.url);
    if (req.url.match('^http') || req.url.match('^webesse3') ) {

      // tentativo di modiicare lo user-agent
      // if ( req.url.match('\/refresh.do') || req.url.match('\/ping.do') ) {
      //   const ua = req.headers.get('User-Agent');
      //   req = req.clone({
      //     setHeaders: {
      //       'User-Agent': 'Java/*'
      //     }
      //   });
      // }
    // if (req.url.match('^http') || req.url.match('^configui')) { o proxata per il configserver-ui
        // richiesta ad un url esplicito la passiamo senza modifiche
        // console.log('request to external url', req.url);
    } else if (req.url.match('/assets\/i18n')) {
      // richiesta del translate service rimuoviamo solo lo / iniziale
      const newUrlS = req.url.substring(1, req.url.length);
      req = req.clone( {url: newUrlS });
    } else {
      // richiesta interna, la completiamo con url del backend e (successivamente con ) header di autorizzazione se disponibilie
      // console.log('this.envService.API ' + this.envService.API);
      const newUrlS = this.envService.API + req.url;
      req = req.clone( {url: newUrlS });


    }

    // console.log('token--->', token);
    // console.log('request headers' + JSON.stringify(req.headers));
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      // console.log('added token to the request headers --> ' + JSON.stringify(req.headers));
    }
    // console.log(`sending following request to url ${req.url}: `);
    // console.log(`headers --> ${JSON.stringify(req.headers)}`);
    // console.log(`request --> ${JSON.stringify(req)}`);

    return next.handle(req)
    .pipe(tap(
      (response: HttpEvent<any>) => {
        if (req.url.match('assets\/i18n')) { // this runs always
          // console.log(`request to url ${req.url} gives following response (assets & i18n) 
          //          ${JSON.stringify(response).substring(1, 20)}... (type 0 means 'sent')`);
        } else {
          // console.log(`request to url ${req.url} gives following response
          //          ${JSON.stringify(response).substring(1, 20)}...  (type 0 means 'sent')`);
        }
      },
      (error: HttpErrorResponse) => {
        console.log(`request to url ${req.url} gives following ERROR ${JSON.stringify(error)}` ); // this runs when you get error
        // console.log('error.error' + error.error ); // this runs when you get error
        // console.log('error.message' + error.message ); // this runs when you get error
        //  console.log('error.status' + error.status);
        // console.log('error.exception' + error.error['exception']);
      if (this.authService.isAuthExpired() ) {
          // this.presentToast('Sessione scaduta');
          // this.navCtrl.navigateRoot('auth');
          this.events.logout.next({authExpired: true});
        } else {
          // non va bene, in tutti i casi di errore codificati darebbe il problema
          // verificare la situazione di disconnessione a fine token
          // if (error.error && !error.error['exception']) {
          //   this.utilityService.presentToast(this.translate.instant('app.component.error'));
          // }
        }
        console.log('error in interceptor' , error);
        return throwError(error);
      },
      () => {
        //  console.log(`request to url ${req.url} complete` ); // this runs when you don't get error
      }
    ));

    /*
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          console.log('event--->', event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (error.error.success === false) {
            console.log('Login failed');
            this.presentToast('Login failed');
          } else {
            console.log('401 --> go to login');
            this.router.navigate(['login']);
          }
        }
        return throwError(error);
      }));
      */
  }

}
